import { Component, TemplateRef } from '@angular/core';
import { ToastService } from 'src/app/pages/dashboards/dashboard/toast-service';

@Component({
	selector: 'app-toast',
	templateUrl: './toast.component.html',
	styleUrls: ['./toast.component.scss'],
	host: {
		class: 'toast-container position-absolute top-0 end-0',
		style: 'z-index: 1200; right: 15px !important',
	},
})
export class ToastComponent {
	title = 'Bootstrap 5 Toast';
	message = 'Hello, world! This is a toast message.';
	show = false;
	toasts: any[] = [];

	ngOnInit() {
		this.toastService.toastSubject.subscribe((toasts: any) => {
			if (Array.isArray(toasts)) {
				this.toasts = toasts;
			}
			this.showToast();
		});
	}

	constructor(public toastService: ToastService) {}

	showToast() {
		this.show = true;
		setTimeout(() => {
			this.show = false;
			this.toastService.toasts = [];
		}, 5000);
	}





}
